import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, NavigationEnd } from '@angular/router';
import { LoginService } from '../services/login.service';
import { Observable, of, from } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { SharedDataService } from 'src/app/services/sharedDataService.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  canUsePortal: boolean = false;
  isDealerPortal: boolean = false;

  constructor(private router: Router, private loginService: LoginService,
    private sharedData: SharedDataService) {
      this.sharedData.currentData.subscribe(data => {
        this.isDealerPortal = data.isDealerPortal;
      });
    // Subscribe to user data to check portal access
    this.loginService.userData$.subscribe((userData: any) => {
      this.canUsePortal = userData?.queryUserPageInfoResDTO?.status == 2;
    });
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const token = localStorage.getItem('token');
    let country = localStorage.getItem("country");
    const url = state.url;

    if (!country) {
      // Default /iam
      localStorage.setItem("country", "/iam");
      country = "/iam";
    }

    // Automatically match country when manually specifying URL
    const matchedOrg =  this.getOrgByUrl(url);
    if (matchedOrg) {
      country = matchedOrg;
    }
    // Get the requiresAuthCheck parameter from route data
    const requiresAuthCheck = next.data['requiresAuthCheck'];

    // Check if requiresAuthCheck is true and matchedOrg has changed
    if (requiresAuthCheck) {
      if(matchedOrg && matchedOrg !== localStorage.getItem("previous_org")){
        localStorage.setItem("previous_org", matchedOrg)
        return from(this.getMenuList()).pipe(
          switchMap(() => {
            const menu = localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu') as string) : [];
            const urlStr = matchedOrg ? url.match(/^[^;?]*/)![0].substring(matchedOrg.length+1) : url;
            const result = menu.some((item: any) => item.url.includes(urlStr));
            if (result) {
              return of(true);
            }
            this.router.navigate([`${country}/no-auth`]);
            return of(false);
          }),
          catchError(() => {
            this.router.navigate([`${country}/no-auth`]);
            return of(false);
          })
        );
      }else{
        let menu = localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu') as string) : [];
        localStorage.setItem("previous_org", matchedOrg)
        const result = menu.some((item: any) => {
          let urlStr = url;
          if (matchedOrg) {
            urlStr = url.match(/^[^;?]*/)![0].substring(matchedOrg.length+1);
          }
          return item.url.includes(urlStr);
        });
        if (result) {
          return of(true);
        }
        this.router.navigate([`${country}/no-auth`]);
        return of(false);
      }

    }


    // If not requiresAuthCheck or matchedOrg has not changed, proceed
    localStorage.setItem("previous_org", matchedOrg)
    return of(true);
  }



  getOrgByUrl(url:string): string {
    // Automatically match country when manually specifying URL
    const match = url.split('/');
    if (match) {

      localStorage.setItem('country', `/${match[1]}`);
      return match[1];
    }
    return "";
  }

  processMenu(menu: any, config: any): any[] {
    const menuItems: any[] = [];

    menu.childNode.forEach((subMenu: any) => {
      if (!subMenu.isHide && subMenu.menuName !== '公共API') {
        const item: any = {
          title: config?.language === 'en' ? subMenu.menuEnName: subMenu.menuName,
          url: subMenu.menuUri,
        };

        // if has childNode
        if (subMenu.childNode && subMenu.childNode.length > 0) {
          item.childNode = this.processMenu(subMenu, config); // 递归调用
        }

        menuItems.push(item);
      }
    });

    return menuItems;
  }

  getMenuList(): Observable<any> {
    let systemId = '6';
    if(!this.isDealerPortal) {
      systemId = '8'
    }
    return from(this.loginService.getMenuList({ systemId }).toPromise()).pipe(
      switchMap((result: any) => {
        const { code, data } = result;
        if (code === 200) {
          const originMenuData = [...data];
          let config: any = localStorage.getItem('template_config');
          if (config) {
            config = JSON.parse(config);
          }
          // Prepare portal (menu)
          let processedMenu:any[] = [];
          originMenuData.forEach((menu: any) => {
            const items = this.processMenu(menu, config);
            processedMenu.push(...items);
          });

          // Set menu
          localStorage.setItem("menu", JSON.stringify(processedMenu));
        }
        return of(null); // Ensure to return Observable
      }),
      catchError(() => of(null)) // Handle errors gracefully
    );
  }
}
